"use strict";

var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

const HEADER = document.getElementById("header"),
	headerRects = HEADER.getBoundingClientRect(),
	headerHeight = headerRects.height + headerRects.top;

(() => {
	document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);

	window.addEventListener('scroll', scrollW);

	// Background Stop

	const stop = document.getElementsByClassName("background-stop")[0];
	stop && new ResizeObserver(() => {
		document.documentElement.style.setProperty("--stop", `${stop.getBoundingClientRect().top + window.scrollY}px`);
	}).observe(document.documentElement);

	// Remove empty <p> tags created by TinyMCE

	for (const p of document.getElementsByTagName("p")) {
		p.innerHTML.trim() === '' && p.remove();
	}

	// Split text into individual letter spans

	const escMap = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
	const esc = s => s.replace(/[&<>"']/g, match => escMap[match]);

	document.querySelectorAll('.title.animate-fade').forEach(el => {
		let globalIdx = 0;
		let newHtml = '';

		el.childNodes.forEach(node => {
			if (node.nodeType === Node.TEXT_NODE) {
				const parts = node.textContent.match(/\S+|\s+/g) || [];

				newHtml += parts.map(part => {
					if (/\s+/.test(part)) {
						return part;
					} else {
						const letters = Array.from(part).map(ch =>
							`<i style="--idx:${globalIdx++}">${esc(ch)}</i>`
						).join('');

						return `<span class="word">${letters}</span>`;
					}
				}).join('');
			} else {
				newHtml += node.outerHTML || node.textContent;
			}
		});

		el.innerHTML = newHtml;
	});

	// ScrollTo Animation

	window.location.hash && animateTo(window.location.hash.substring(1));

	document.querySelectorAll('[href*="#"]:not([data-lbx]').forEach(cta => {
		let target = cta.hash.substring(1);

		if (!document.getElementById(target))
			return;

		cta.addEventListener("click", (e) => {
			e.preventDefault();
			animateTo(target);
		});
	});

	// Button effect

	const updateOffset = (target, e) => {
		const rect = target.getBoundingClientRect();

		target.style.setProperty('--top', `${e.clientY - rect.top}px`);
		target.style.setProperty('--left', `${e.clientX - rect.left}px`);
	}

	document.addEventListener("pointerover", (e) => {
		const target = e.target.closest(".btn");

		if (!target || target.contains(e.relatedTarget)) return;

		updateOffset(target, e);
	});

	document.addEventListener("pointerout", (e) => {
		const target = e.target.closest(".btn");

		if (!target || target.contains(e.relatedTarget)) return;

		updateOffset(target, e);
	});

	// Toggle Buttons

	document.querySelectorAll(".js-toggle").forEach(btn => {
		let target = document.getElementById(btn.dataset.target);

		if (!target)
			return;

		btn.addEventListener("click", (e) => {
			e.preventDefault();
			target.classList.toggle("active");
		});
	});

	const toggleGroups = new Map();

	const findPanel = (el) => document.getElementById(el.dataset.target) || (el.nextElementSibling && el.nextElementSibling.hasAttribute("aria-expanded") && el.nextElementSibling);

	document.addEventListener("click", (e) => {
		const el = e.target.closest(".js-toggle-active");

		if (!el)
			return;

		const groupKey = el.dataset.group || 'default';

		const panel = findPanel(el);

		let entry = toggleGroups.get(groupKey);

		if (!entry && el.dataset.group) {
			const activeEl = document.querySelector(`.js-toggle-active.active[data-group="${groupKey}"]`);

			if (activeEl)
				entry = { summary: activeEl, content: findPanel(activeEl) };
		}

		if (entry && entry.summary !== el) {
			entry.summary.classList.remove("active");
			entry.content && entry.content.setAttribute("aria-expanded", false);
			toggleGroups.delete(groupKey);
		}

		el.classList.toggle("active");
		panel && panel.setAttribute("aria-expanded", el.classList.contains("active"));

		if (el.classList.contains("active"))
			toggleGroups.set(groupKey, { summary: el, content: panel });
		else
			toggleGroups.delete(groupKey);
	});

	// Set Up Animations

	addAnimations(".global-sitemap", "top");

	// Custom animation ratio observer

	const animateObserver = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			entry.target.classList.toggle("visible", entry.intersectionRatio > 0.8);
		});
	}, {
		threshold: [0.8]
	});

	document.querySelectorAll(".animate").forEach(el => animateObserver.observe(el));

	// Custom animation observer

	const animationObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				let element = entry.target;
				element.classList.add("fade-in");
				animationObserver.unobserve(element);
			}
		});
	});

	// Custom resize functions

	const resizeObserver = new ResizeObserver(entries => {
		entries.forEach(entry => {
			const element = entry.target;

			element.dataset.target
				? document.getElementById(element.dataset.target).style.setProperty("--offset", `${element.scrollHeight}px`)
				: element.style.setProperty("--offset", `${element.scrollHeight}px`);
		})
	});

	document.querySelectorAll(".js-offset").forEach(element => resizeObserver.observe(element));

	// Custom functions

	new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			mutation.addedNodes.forEach(node => {
				if (node.nodeType === 1) {
					node.matches(".animate-fade") && animationObserver.observe(node);
					node.matches(".js-offset") && resizeObserver.observe(node);

					node.querySelectorAll(".animate-fade").forEach(element => animationObserver.observe(element));
					node.querySelectorAll(".js-offset").forEach(element => resizeObserver.observe(element));
				}
			});
		});
	}).observe(document.getElementById("content"), { childList: true, subtree: true });
})();

function scrollW() {
	const scrollTop = document.documentElement.scrollTop;

	if (scrollTop < 80) {
		HEADER.classList.remove('up', 'down');
	} else {
		HEADER.classList.toggle('down', scrollTop > lastScrollTop);
		HEADER.classList.toggle('up', scrollTop <= lastScrollTop);
	}

	lastScrollTop = Math.max(scrollTop, 0);  // Ensure lastScrollTop doesn't go below 0
}

function animateTo(target) {
	const toTarget = document.getElementById(target);

	if (!toTarget)
		return;

	const from = window.scrollY;
	const to = toTarget.getBoundingClientRect().top + from - (headerHeight * 1.5);
	const duration = 1400;
	const start = performance.now();

	const easeInOutQuart = t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;

	function step(timestamp) {
		const time = timestamp - start;
		const progress = Math.min(time / duration, 1);
		const yH = easeInOutQuart(progress) * (to - from) + from;

		window.scrollTo(0, yH);

		time < duration && requestAnimationFrame(step);
	}

	requestAnimationFrame(step);
}

function addAnimations(selector, behavior = null) {
	for (const item of document.querySelectorAll(selector)) {
		item.classList.add("animate-fade", behavior);
	}
}